import React from 'react';

import { Icon } from 'b3';
import FergusLogo from '../../FergusLogo';
import TimelineItem from './TimelineItem';

export default function UservoiceResponseTimelineItem(props) {
	var icon 	= <Icon icon="volume-loud-1" />;
	var avatar = <FergusLogo className="avatar" />;
    var typeLabel = <span>Uservoice<br/>Response</span>;


    var isLongContent = (props.response.length > 230);

    return (
        <TimelineItem
        	type="uservoiceresponse"
            typeLabel={typeLabel}
        	avatar={avatar}
        	icon={icon}
            isLongContent={isLongContent}
        >
        	<span className="taskSpan" dangerouslySetInnerHTML={{__html: props.response}}></span>
        </TimelineItem>
    );
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/UservoiceResponseTimelineItem.js